import { render } from "./RequirementCorrectionModal.vue?vue&type=template&id=2a62e000&scoped=true"
import script from "./RequirementCorrectionModal.vue?vue&type=script&lang=js"
export * from "./RequirementCorrectionModal.vue?vue&type=script&lang=js"

import "./RequirementCorrectionModal.vue?vue&type=style&index=0&id=2a62e000&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a62e000"]])

export default __exports__